export default __webpack_public_path__ + "static/24-37e29f279ee25c73a0fde5472c9533be.jpg";